import { Component, OnInit } from '@angular/core';
/* import { Socket } from 'ngx-socket-io'; */
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent implements OnInit {
  displayForAdmin = false;
  constructor(private route: ActivatedRoute) {

  }

  ngOnInit() {
    if (this.route.snapshot.params.id && window.location.href.indexOf('chat-admin')>-1) {
      this.displayForAdmin = true;
    }
  }


}

